/**
 * 필드 표시 여부를 판단하는 재사용 가능한 유틸리티 함수
 * 
 * fieldDisplayRules.js에 정의된 규칙을 기반으로 필드 표시 여부와 필수 여부를 판단합니다.
 */

import { FIELD_DISPLAY_RULES } from './fieldDisplayRules';

/**
 * 필드 표시 여부 확인
 * @param {string} fieldName - 필드명 (FIELD_DISPLAY_RULES의 키)
 * @param {object} context - 컨텍스트 객체
 *   - baseFeeCalcType: 기본요금 계산 방식
 *   - hasFlatCost: 단일 요금제 여부 (0 또는 1)
 *   - hasProgressive: 누진 요금제 여부 (0 또는 1)
 *   - hasTimeSlot: 시간대별 요금제 여부 (0 또는 1)
 *   - hasSeason: 계절별 요금제 여부 (0 또는 1)
 *   - hasDayType: 요일별 요금제 여부 (0 또는 1)
 *   - energySourceCode: 에너지 유형 코드 (예: 'GAS', 'ELEC')
 * @returns {boolean} 표시 여부
 */
export function shouldShowField(fieldName, context = {}) {
    const rule = FIELD_DISPLAY_RULES[fieldName];
    if (!rule) {
        console.warn(`Field display rule not found for: ${fieldName}`);
        return false;
    }
    
    if (typeof rule.show === 'function') {
        return rule.show(context);
    }
    
    return rule.show === true;
}

/**
 * 필드 필수 여부 확인
 * @param {string} fieldName - 필드명 (FIELD_DISPLAY_RULES의 키)
 * @param {object} context - 컨텍스트 객체
 * @returns {boolean} 필수 여부
 */
export function isFieldRequired(fieldName, context = {}) {
    const rule = FIELD_DISPLAY_RULES[fieldName];
    if (!rule) {
        return false;
    }
    
    if (typeof rule.required === 'function') {
        return rule.required(context);
    }
    
    return rule.required === true;
}

/**
 * 표시 가능한 필드 목록 조회
 * @param {object} context - 컨텍스트 객체
 * @returns {string[]} 필드명 배열
 */
export function getVisibleFields(context = {}) {
    return Object.keys(FIELD_DISPLAY_RULES).filter(fieldName => 
        shouldShowField(fieldName, context)
    );
}

/**
 * 필수 필드 목록 조회
 * @param {object} context - 컨텍스트 객체
 * @returns {string[]} 필드명 배열
 */
export function getRequiredFields(context = {}) {
    return Object.keys(FIELD_DISPLAY_RULES).filter(fieldName => 
        isFieldRequired(fieldName, context)
    );
}

